import {StoreItem} from "../../../../app/store/store";

export const MAX_MONTHS = 4;

/** A VIP (or any item the backend tagged with per-month totals) supports 1..MAX_MONTHS selection. */
export function hasMonthOptions(item: StoreItem): boolean {
    return !!item.month_prices && Object.keys(item.month_prices).length > 0;
}

/** Single-month price for the given currency. */
export function monthlyPrice(item: StoreItem, currencyName: string): number {
    return item.price[currencyName] ?? 0;
}

/** Authoritative total for N months: the backend's precomputed value, else linear fallback. */
export function totalForMonths(item: StoreItem, months: number, currencyName: string): number {
    const fromBackend = item.month_prices?.[months.toString()]?.[currencyName];
    if (fromBackend !== undefined) return fromBackend;
    return monthlyPrice(item, currencyName) * months;
}

/** How much the player saves vs. paying the monthly price N times. Never negative. */
export function savingsForMonths(item: StoreItem, months: number, currencyName: string): number {
    return Math.max(0, monthlyPrice(item, currencyName) * months - totalForMonths(item, months, currencyName));
}

/**
 * Effective discount on the whole bundle for N months, as a rounded percentage (0..100).
 * Grows with months on discounted tiers (e.g. Pterodactyl: 0 / 5 / 10 / 15 %), 0 on linear ones.
 */
export function discountPercentForMonths(item: StoreItem, months: number, currencyName: string): number {
    const regular = monthlyPrice(item, currencyName) * months;
    if (regular <= 0) return 0;
    return Math.round(savingsForMonths(item, months, currencyName) / regular * 100);
}
